/**
 * Promo Line Rotation
 * Handles automatic rotation of multiple promo banners
 */
class PromoLineRotation {
    constructor() {
        this.container = document.querySelector('.promo-line-container')
        this.promos = document.querySelectorAll('.promo-line')
        this.currentIndex = 0
        this.rotationInterval = null
        this.rotationDelay = 8000 // 8 seconds
        this.fadeDuration = 500 // 0.5 seconds

        this.init()
    }

    init() {
        if (!this.container || this.promos.length <= 1) {
            return // No rotation needed
        }

        this.setupPromos()
        this.startRotation()
        this.setupEventListeners()
    }

    setupPromos() {
        // Ensure only the first promo is visible initially
        this.promos.forEach((promo, index) => {
            if (index === 0) {
                promo.classList.add('active')
                promo.style.opacity = '1'
            } else {
                promo.classList.remove('active')
                promo.style.opacity = '0'
            }
        })
    }

    startRotation() {
        this.rotationInterval = setInterval(() => {
            this.rotateToNext()
        }, this.rotationDelay)
    }

    stopRotation() {
        if (this.rotationInterval) {
            clearInterval(this.rotationInterval)
            this.rotationInterval = null
        }
    }

    rotateToNext() {
        const nextIndex = (this.currentIndex + 1) % this.promos.length
        this.rotateToIndex(nextIndex)
    }

    rotateToIndex(index) {
        if (index === this.currentIndex || index >= this.promos.length) {
            return
        }

        const currentPromo = this.promos[this.currentIndex]
        const nextPromo = this.promos[index]

        // Fade out current promo
        this.fadeOut(currentPromo, () => {
            // Fade in next promo
            this.fadeIn(nextPromo)
            this.currentIndex = index
        })
    }

    fadeOut(element, callback) {
        element.style.transition = `opacity ${this.fadeDuration}ms ease-in-out`
        element.style.opacity = '0'

        setTimeout(() => {
            element.classList.remove('active')
            if (callback) callback()
        }, this.fadeDuration)
    }

    fadeIn(element) {
        element.classList.add('active')
        element.style.transition = `opacity ${this.fadeDuration}ms ease-in-out`
        element.style.opacity = '1'
    }

    setupEventListeners() {
        // Pause rotation on hover
        this.container.addEventListener('mouseenter', () => {
            this.stopRotation()
        })

        // Resume rotation when mouse leaves
        this.container.addEventListener('mouseleave', () => {
            this.startRotation()
        })

        // Pause rotation when user interacts with promo
        this.promos.forEach((promo) => {
            promo.addEventListener('click', () => {
                this.stopRotation()
            })
        })

        // Handle visibility change (pause when tab is not active)
        document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                this.stopRotation()
            } else {
                this.startRotation()
            }
        })
    }

    // Public method to manually rotate to specific promo
    goToPromo(index) {
        this.stopRotation()
        this.rotateToIndex(index)
        this.startRotation()
    }

    // Public method to get current promo index
    getCurrentIndex() {
        return this.currentIndex
    }

    // Public method to get total promo count
    getPromoCount() {
        return this.promos.length
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => new PromoLineRotation())
